import React from 'react'
import PageBanner from "app/components/ui/PageBanner"
import SiteGrid from "app/components/ui/SiteGrid"
import HelmetTitle from "app/meta/HelmetTitle"
import './styles/PolicyPage.css'

export default function DisclaimerPage() {
  return (
    <div className="disclaimer-page policy-page">
      <HelmetTitle title="Disclaimer" />
      <PageBanner
        title="Disclaimer"
        subtitle="Read our disclaimer before using our website."
      />
      <SiteGrid>
        <div className="page-content">
          <h1>Disclaimer for Aphrodite</h1>
          <p>
            The information provided on this website is for general
            informational purposes only and is not intended as medical
            advice. It is not a substitute for professional medical
            advice, diagnosis, or treatment. Always seek the advice
            of your healthcare provider with any questions you may have
            regarding a medical condition. Never disregard professional
            medical advice or delay in seeking it because of something
            you have read on this website.
          </p>
          <br /><br />
          <p>
            The information on this website is provided "as is" and without warranty
            of any kind, either express or implied, including but not limited to
            the implied warranties of merchantability, fitness for a particular
            purpose, or non-infringement. Aphrodite Clinic does not warrant that
            the information on this website is accurate, complete, or current.
          </p>
          <br /><br />
          <p>
            Aphrodite Clinic assumes no liability for any direct, indirect, incidental,
            special, or consequential damages arising out of or in any way connected
            with the use of this website or the information contained herein. This
            includes, but is not limited to, damages for loss of profits, business
            interruption, or loss of data.
          </p>
          <br /><br />
          <p>
            Contact us at <a href="mailto:info@aphrodite.com">info@aphrodite.com</a> with
            any questions or concerns regarding this disclaimer or the content on this website.
          </p>
        </div>
      </SiteGrid>
    </div>
  )
}
